import {inject} from '@angular/core';
import {
  ActivatedRouteSnapshot, CanActivateChildFn,
  CanActivateFn,
  RouterStateSnapshot
} from '@angular/router';

import {RolesService} from './roles.service';

export const RouteGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const rolesService = inject(RolesService);
  if (route.component) {
    return rolesService.hasRoleByComponent(route.component);
  }
  return false;
};
